import { useState } from "react";
import { useMutation } from "@apollo/client";
import { GRANT_ADMIN } from "../queries/waves";

// Super-admin-only utility. The backend rejects the call unless the caller's
// email matches SUPER_ADMIN_EMAIL, so we render the form for any admin and let
// the server enforce the privilege (guide §2 Step 1).
export default function GrantAdminPanel() {
    const [userId, setUserId] = useState("");
    const [result, setResult] = useState(null); // { ok: bool, msg: string }
    const [grantAdmin, { loading }] = useMutation(GRANT_ADMIN);

    const submit = async (e) => {
        e.preventDefault();
        setResult(null);
        try {
            const { data } = await grantAdmin({ variables: { userId } });
            setResult(data?.grantAdmin
                ? { ok: true, msg: `User ${userId} is now an admin.` }
                : { ok: false, msg: "The server did not confirm the change." });
        } catch (err) {
            setResult({ ok: false, msg: err.message });
        }
    };

    return (
        <div>
            <h1>Admin access</h1>
            <div className="admin-section" style={{ maxWidth: 480 }}>
                <h3>Grant admin</h3>
                <p style={{ color: "#666", fontSize: 13 }}>
                    Promote a user to admin by their user ID. Only the super admin
                    (the account matching <code>SUPER_ADMIN_EMAIL</code>) can do this.
                </p>
                <form onSubmit={submit} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <input
                        placeholder="User ID"
                        value={userId}
                        onChange={(e) => setUserId(e.target.value)}
                        required
                    />
                    <button className="admin-btn admin-btn-primary" type="submit" disabled={loading || !userId}>
                        {loading ? "Granting…" : "Grant admin"}
                    </button>
                </form>
                {result && (
                    <p style={{ marginTop: 12, color: result.ok ? "#16a34a" : "crimson", fontSize: 14 }}>
                        {result.msg}
                    </p>
                )}
            </div>
        </div>
    );
}
